import {Splide} from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

export default (params) => ({
    slider: null,
    progressBar: null,
    sliderIsInitialized: false,
    init() {
        this.initSlider()
    },
    initSlider() {
        if (this.$el.classList.contains("splide")) {
            this.slider = new Splide(this.$el, {
                ...params,
            })

            this.progressBar = this.$el.querySelector( '.custom-slider-progress-bar' );

            if (this.slider){
                if (this.progressBar){
                    this.slider.on('mounted move', () => this.calculateProgressBarWidth())

                    window.addEventListener("resize", ()=>{
                        if (window.innerWidth <= 990){
                            this.slider.on('mounted move', () => this.calculateProgressBarWidth())
                        }
                    })
                }

                this.slider.on('ready', ()=> {
                    this.sliderIsInitialized = true
                })
            }

            this.slider.mount({AutoScroll});
        }
    },
    calculateProgressBarWidth(){
        const end = this.slider.Components.Controller.getEnd() + 1;
        const rate = Math.min((this.slider.index + 1) / end, 1);

        if (this.progressBar){
            this.progressBar.style.width = String(100 * rate) + '%';
        }
    }
})
